import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import BusinessPlan from "@/views/businessPlan.vue";
import Steps from "@/views/Steps.vue";
import rm from "@/views/rm.vue";
import Condition from "@/views/Conditon.vue";
import ProfilsDesInvestisseurs from "@/views/Steps/vous_et_votre_projet/ProfilsDesInvestisseurs.vue";
import VotreProjet from "@/views/Steps/vous_et_votre_projet/VotreProjet.vue";
import VotreEntreprise from "@/views/Steps/vous_et_votre_projet/votre_project/VotreEntreprise.vue";
import _VotreProjet from "@/views/Steps/vous_et_votre_projet/votre_project/VotreProject.vue";
import Offers from "@/views/Steps/vous_et_votre_projet/votre_project/Offers.vue";
import Clients from "@/views/Steps/vous_et_votre_projet/votre_project/clients.vue";
import SuccessMessage1 from "@/views/Steps/vous_et_votre_projet/votre_project/SuccessMessage.vue";
import TaillEetevolutionDuMarche from "@/views/Steps/etude_de_marche/TaillEetevolutionDuMarche.vue";
import GeographicalDistribution from "@/views/Steps/etude_de_marche/GeographicalDistribution.vue";
import SanteFinanciereDesEntreprises from "@/views/Steps/etude_de_marche/SanteFinanciereDesEntreprises.vue";
import PrincipauxActeursEtPartDuMarche from "@/views/Steps/etude_de_marche/PrincipauxActeursEtPartDuMarche.vue";
import AnalyseConcurrentielle from "@/views/Steps/etude_de_marche/AnalyseConcurrentielle.vue";
import MoyensCommerciaux from "@/views/Steps/etude_de_marche/MoyensCommerciaux.vue";
import SuccessMessage2 from "@/views/Steps/etude_de_marche/SuccessMessage.vue";
import MoyensFonciersEtImmeubles from "@/views/Steps/etude_technique/MoyensFonciersEtImmeubles.vue";
import MoyensDexploitation from "@/views/Steps/etude_technique/MoyensDexploitation.vue";
import InstallationsTech from "@/views/Steps/etude_technique/moyen_dexploitation/installationsTech.vue";
import MaterielInformatique from "@/views/Steps/etude_technique/moyen_dexploitation/materielInformatique.vue";
import ITMO from "@/views/Steps/etude_technique/moyen_dexploitation/itmo.vue";
import MaterielsEtOutil from "@/views/Steps/etude_technique/moyen_dexploitation/materielsEtOutil.vue";
import MobillierEtBureaux from "@/views/Steps/etude_technique/moyen_dexploitation/mobillierEtBureaux.vue";
import MoyensDeTransports from "@/views/Steps/etude_technique/moyen_dexploitation/moyensDeTransports.vue";
import MoyensHumains from "@/views/Steps/etude_technique/MoyensHumains.vue";
import SuccessMessage3 from "@/views/Steps/etude_technique/SuccessMessage.vue";
import ProgrammeDinvestissementPlanDeFinancement from "@/views/Steps/etude_financiere/ProgrammeDinvestissementPlanDeFinancement.vue";
import InvestorProgramme from "@/views/Steps/etude_financiere/investorProgrameSV.vue";
import ChiffresDaffairesPrevisionnels from "@/views/Steps/etude_financiere/ChiffresDaffairesPrevisionnels.vue";
import AchatsPrevisionnels from "@/views/Steps/etude_financiere/AchatsPrevisionnels.vue";
import ChargePrevisionnels from "@/views/Steps/etude_financiere/cahrgePrevisionnel.vue";
import AutresChargesExternes from "@/views/Steps/etude_financiere/AutresChargesExternes.vue";
import ChargesDuPersonnel from "@/views/Steps/etude_financiere/ChargesDuPersonnel.vue";
import BusinessPlanVersion from "@/views/BusinessPlanVersion.vue";
import NotFound from "@/views/notFound.vue";
import Guide from "@/views/Guide.vue";
import tmp from "@/views/tmp.vue";
import validatedBpi from "@/views/admin/validatedBpi.vue";
import bpiInProcessing from "@/views/admin/bpiInProcessing.vue";
import bpiAnalytics from "@/views/admin/bpiAnalytics.vue";
import Validation from "@/views/Steps/etude_financiere/MessageValidation.vue";
import NProgress from "nprogress";

import Admin from "@/views/admin.vue";
import output from "@/views/output.vue";
import store from "@/store";

import { auth } from "@/services/firebase.service";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: { requiresAuth: false, requiresGuest: false }
    },
    {
        path: "/business_plan",
        name: "business_plan",
        component: BusinessPlan,
        meta: { requiresAuth: true }
    },
    {
        path: "/business_plan/version",
        name: "business_plan_version",
        component: BusinessPlanVersion,
        meta: { requiresAuth: true }
    },
    {
        path:
            "/business_plan/:uid/vous_et_votre_projet/profils_des_investisseurs",
        name: "profils_des_investisseurs",
        component: ProfilsDesInvestisseurs,
        meta: {
            requiresAuth: true,
            steps: ["Vous et votre projet", "Profils des investisseurs"]
        }
    },
    {
        path: "/business_plan/:uid/vous_et_votre_projet/votre_projet",
        name: "votre_projet",
        component: VotreProjet,
        children: [
            {
                path: "votre_entreprise",
                name: "votre_entreprise",
                component: VotreEntreprise,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Vous et votre projet",
                        "Votre Projet",
                        "Votre Entreprise"
                    ]
                }
            },
            {
                path: "votre_projet",
                name: "_votre_projet",
                component: _VotreProjet,
                meta: {
                    requiresAuth: true,
                    steps: ["Vous et votre projet", "Votre Projet"]
                }
            },
            {
                path: "vos_offres",
                name: "vos_offres",
                component: Offers,
                meta: {
                    requiresAuth: true,
                    steps: ["Vous et votre projet", "Votre Offres"]
                }
            },
            {
                path: "vos_clients",
                name: "vos_clients",
                component: Clients,
                meta: {
                    requiresAuth: true,
                    steps: ["Vous et votre projet", "Vos Clients"]
                }
            },
            {
                path: "success_message",
                name: "success_message1",
                component: SuccessMessage1,
                meta: {
                    requiresAuth: true,
                    steps: ["Vous et votre projet", "Message de Succès"]
                }
            }
        ]
    },
    {
        path:
            "/business_plan/:uid/etude_de_marche/taille_et_evolution_du_marche",
        name: "taille_et_evolution_du_marche",
        component: TaillEetevolutionDuMarche,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Taille et évolution du marché"]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_de_marche/sante_financiere_des_entreprises",
        name: "sante_financiere_des_entreprises",
        component: SanteFinanciereDesEntreprises,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Santé financière Des entreprises"]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_de_marche/Repartition_geographique_des_entreprises",
        name: "geographical_distribution",
        component: GeographicalDistribution,
        meta: {
            requiresAuth: true,
            steps: [
                "Étude de marché",
                "RÉPARTITION GÉOGRAPHIQUE DES ENTREPRISES PAR VILLE"
            ]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_de_marche/principaux_acteurs_et_part_du_marche",
        name: "principaux_acteurs_et_part_du_marche",
        component: PrincipauxActeursEtPartDuMarche,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Principaux acteurs et part du marché"]
        }
    },
    {
        path: "/business_plan/:uid/etude_de_marche/analyse_concurrentielle",
        name: "analyse_concurrentielle",
        component: AnalyseConcurrentielle,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Analyse Concurrentielle"]
        }
    },
    {
        path: "/business_plan/:uid/etude_de_marche/moyens_commerciaux",
        name: "moyens_commerciaux",
        component: MoyensCommerciaux,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Moyens Commerciaux"]
        }
    },
    {
        path: "/business_plan/:uid/etude_de_marche/success_message",
        name: "success_message2",
        component: SuccessMessage2,
        meta: {
            requiresAuth: true,
            steps: ["Étude de marché", "Message de Succès"]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_technique/moyens_fonciers_et_immeubles",
        name: "moyens_fonciers_et_immeubles",
        component: MoyensFonciersEtImmeubles,
        meta: {
            requiresAuth: true,
            steps: ["Étude Technique", "Moyens fonciers et immeubles"]
        }
    },
    {
        path: "/business_plan/:uid/etude_technique/moyens_dexploitation",
        name: "moyens_dexploitation",
        component: MoyensDexploitation,
        children: [
            {
                path: "installations_techniques",
                name: "installations_techniques",
                component: InstallationsTech,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "Installations techniques"
                    ]
                }
            },
            {
                path: "materiels_et_outillage",
                name: "materiels_et_outillage",
                component: MaterielsEtOutil,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "Matériels et outillage"
                    ]
                }
            },
            {
                path: "moyens_de_transports_et_manutentions",
                name: "moyens_de_transports_et_manutentions",
                component: MoyensDeTransports,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "Moyens de transports et manutentions"
                    ]
                }
            },
            {
                path: "mobilier_et_bureaux",
                name: "mobilier_et_bureaux",
                component: MobillierEtBureaux,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "Mobilier et bureaux"
                    ]
                }
            },
            {
                path: "materiel_informatique",
                name: "materiel_informatique",
                component: MaterielInformatique,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "Matériel Informatique"
                    ]
                }
            },
            {
                path: "i_t_m_o",
                name: "i_t_m_o",
                component: ITMO,
                meta: {
                    requiresAuth: true,
                    steps: [
                        "Étude Technique",
                        "Moyens d’exploitation",
                        "I_T_M_O"
                    ]
                }
            }
        ]
    },
    {
        path: "/business_plan/:uid/etude_technique/moyens_humains",
        name: "moyens_humains",
        component: MoyensHumains,
        meta: {
            requiresAuth: true,
            steps: ["Étude Technique", "Moyens humains"]
        }
    },
    {
        path: "/business_plan/:uid/etude_technique/success_message",
        name: "success_message3",
        component: SuccessMessage3,
        meta: {
            requiresAuth: true,
            steps: ["Étude Technique", "Message de Succès"]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_financiere/programme_dinvestissement_plan_de_financement",
        name: "programme_dinvestissement_plan_de_financement",
        component: ProgrammeDinvestissementPlanDeFinancement,
        meta: {
            requiresAuth: true,
            steps: [
                "Étude Financiere",
                "Programme d’investissement plan de financement"
            ]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_financiere/programme_dinvestissement_et_plan_de_financement",
        name: "programme_dinvestissement_et_plan_de_financement",
        component: InvestorProgramme,
        meta: {
            requiresAuth: true,
            steps: [
                "Étude Financiere",
                "Programme d’investissement plan de financement"
            ]
        }
    },
    {
        path:
            "/business_plan/:uid/etude_financiere/chiffres_daffaires_previsionnels",
        name: "chiffres_daffaires_previsionnels",
        component: ChiffresDaffairesPrevisionnels,
        meta: {
            requiresAuth: true,
            steps: ["Étude Financiere", "Chiffres d’affaires Prévisionnels"]
        }
    },
    {
        path: "/business_plan/:uid/etude_financiere/achats_previsionnels",
        name: "achats_previsionnels",
        component: AchatsPrevisionnels,
        meta: {
            requiresAuth: true,
            steps: ["Étude Financiere", "Achats Prévisionnels"]
        }
    },
    {
        path: "/business_plan/:uid/etude_financiere/charges_previsionnels",
        name: "Charges_previsionnels",
        component: ChargePrevisionnels,
        meta: {
            requiresAuth: true,
            steps: ["Étude Financiere", "Charges Prévisionnels"]
        }
    },
    {
        path: "/business_plan/:uid/etude_financiere/autres_charges_externes",
        name: "autres_charges_externes",
        component: AutresChargesExternes,
        meta: {
            requiresAuth: true,
            steps: ["Étude Financiere", "Autres charges externes"]
        }
    },
    {
        path: "/business_plan/:uid/etude_financiere/charges_du_personnel",
        name: "charges_du_personnel",
        component: ChargesDuPersonnel,
        meta: {
            requiresAuth: true,
            steps: ["Étude Financiere", "Charges du personnel"]
        }
    },
    {
        path: "/validation",
        name: "validation",
        component: Validation,
        meta: {
            requiresAuth: true,
            steps: [" "]
        }
    },
    {
        path: "/Steps",
        name: "Steps",
        component: Steps,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/connexion",
        name: "rm",
        component: rm,
        meta: {
            requiresAuth: false,
            requiresGuest: true
        }
    },
    {
        path: "/condition",
        name: "condition",
        component: Condition,
        meta: {
            requiresAuth: false
            // requiresGuest: true,
        }
    },
    {
        path: "/guide_pratique",
        name: "guide_pratique",
        component: Guide,
        meta: {
            requiresAuth: false
            // requiresGuest: true,
        }
    },
    {
        path: "/admin",
        name: "admin",
        component: Admin,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "bpi/validated",
                name: "validated_bpi",
                component: validatedBpi,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "bpi/processing",
                name: "bpi_in_process",
                component: bpiInProcessing,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "bpi/analytics",
                name: "bpi_analytics",
                component: bpiAnalytics,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: "/output",
        name: "output",
        component: output
    },
    {
        path: "/tmp",
        name: "tmp",
        component: tmp
    },
    {
        path: "/*",
        name: "NotFound",
        component: NotFound
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    NProgress.start();
    store.dispatch("Auth/initAuthentication").then(user => {
        if (user) {
            if (store.getters["user/getUser"] === null) {
                store.dispatch("user/fetchUser", auth.currentUser.uid);
            }
        }
        if (to.matched.some(route => route.meta.requiresAuth)) {
            if (user) {
                if (
                    to.name === "admin" ||
                    to.name === "validated_bpi" ||
                    to.name === "bpi_in_process" ||
                    to.name === "bpi_analytics"
                ) {
                    store
                        .dispatch("user/fetchUser", auth.currentUser.uid)
                        .then(user => {
                            if (user.isAdmin) {
                                next();
                            } else {
                                next({
                                    name: "NotFound",
                                    query: { message: "Not Authorized" }
                                });
                            }
                        });
                } else if (
                    store.getters["user/getBpi"].bpi === null &&
                    store.getters["user/getBpi"].bpiUid === null &&
                    to.name !== "business_plan_version"
                ) {
                    let index = user.bpis.findIndex(bpi => {
                        return bpi.id === to.params.uid;
                    });
                    if (index !== -1) {
                        store
                            .dispatch("user/fetchBpi", to.params.uid)
                            .then(status => {
                                if (status === "success") {
                                    next();
                                } else {
                                    next({
                                        name: "NotFound",
                                        query: {
                                            message: "Business_Plan_Not_Found"
                                        }
                                    });
                                }
                            });
                    } else {
                        store
                            .dispatch("user/fetchUser", auth.currentUser.uid)
                            .then(user => {
                                if (user.isAdmin) {
                                    store
                                        .dispatch(
                                            "user/fetchBpi",
                                            to.params.uid
                                        )
                                        .then(status => {
                                            if (status === "success") {
                                                next();
                                            } else {
                                                next({
                                                    name: "NotFound",
                                                    query: {
                                                        message:
                                                            "Business_Plan_Not_Found"
                                                    }
                                                });
                                            }
                                        });
                                } else {
                                    next({
                                        name: "NotFound",
                                        query: { message: "Not Authorized" }
                                    });
                                }
                            });
                    }
                } else {
                    next();
                }
            } else {
                next({ name: "rm", query: { redirectTo: to.path } });
            }
        } else if (to.matched.some(route => route.meta.requiresGuest)) {
            // protected route
            if (!user) {
                next();
            } else {
                next({ name: "Home" });
            }
        } else if (to.name === "output") {
            if (to.query.uid !== undefined) {
                const promise1 = store.dispatch(
                    "user/selectBpiOutPutFromParams1",
                    to.query.uid
                );
                const promise2 = store.dispatch(
                    "user/selectBpiOutPutFromParams2",
                    to.query.uid
                );

                Promise.all([promise1, promise2]).then(bpi => {
                    if (bpi[1] === null) {
                        next({
                            name: "NotFound",
                            query: { message: "Not Found" }
                        });
                    } else next();
                });
            } else {
                next({ name: "rm" });
            }
            // else {
            //   // if (store.getters["user/getBpiOutPut"].bpiUid !== null) {
            //   //   next();
            //   // } else {
            //   next({ name: "NotFound", query: { message: "Not Found" } });
            //   // }
            // }
        } else {
            next();
        }
    });
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
